// extracted by mini-css-extract-plugin
export var content = "_nf-1";
export var fullScreen = "_nf-0";